import { TabPanel, TabView } from "primereact/tabview";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CarbonCoefficientComponent from "../inventoryCarbonFootprint/cusComponents/CarbonCoefficientComponent";
import EmissionSource from "./components/emissionSource";
import GWP from "./components/gwp";

const EmissionSourceFactor = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [showIndex, setShowIndex] = useState(false);
  const {
    getValues,
    setValue,
    watch,
    control,
    register,
    trigger,
    handleSubmit,
    clearErrors,
    setError,
    resetField,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {},
    //錯誤驗證時機
    mode: "all",
  });

  const handlePickData = (rowData) => {
    setShowIndex(false);
    setValue("sourceName", rowData?.coefficientName, { shouldValidate: true });
    setValue("cusSourceSeq", rowData?.coefficientId, { shouldValidate: true });
    setValue("keywordSearch", "");
  };

  return (
    <div className="p-card">
      <div className="p-card-body">
        <TabView scrollable renderActiveOnly activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
          <TabPanel header={t("emission_source")}>
            <EmissionSource />
          </TabPanel>

          <TabPanel header={"GWP"}>
            <GWP />
          </TabPanel>

          <TabPanel header={t("carbonFootCoef")}>
            <CarbonCoefficientComponent
              getValues={getValues}
              register={register}
              errors={errors}
              setPickDialog={setShowIndex}
              pickData={handlePickData}
              applyFlag={false}
            />
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};

export default EmissionSourceFactor;
